<wishlist-status-pill
  [label]="label()"
  [iconLabel]="iconLabel()"
  [tone]="tone()"
  [compact]="compact()"
  [ariaLabel]="label()"
/>
